import PropTypes from 'prop-types';
import React from 'react';
import { useLocale } from 'next-intl';

import StyledEventDateA11y from './eventDateA11y.style';
import { LongArrowRight } from '../../icons/arrow/arrow';

const EventDateA11y = props => {
  const {
    startDate,
    endDate,
    period,
    isTeaser = false,
    showWeekday = false,
    timeOnTop = false,
    hasTime = false
  } = props;
  const locale = useLocale();

  const month = {
    de: {
      '01': 'Jan',
      '02': 'Feb',
      '03': 'Mär',
      '04': 'Apr',
      '05': 'Mai',
      '06': 'Jun',
      '07': 'Jul',
      '08': 'Aug',
      '09': 'Sept',
      10: 'Okt',
      11: 'Nov',
      12: 'Dez'
    },
    en: {
      '01': 'Jan',
      '02': 'Feb',
      '03': 'Mar',
      '04': 'Apr',
      '05': 'May',
      '06': 'Jun',
      '07': 'Jul',
      '08': 'Aug',
      '09': 'Sept',
      10: 'Oct',
      11: 'Nov',
      12: 'Dec'
    }
  };

  return (
    <StyledEventDateA11y {...props} isTeaser={isTeaser} timeOnTop={timeOnTop} period={period}>
      <time
        className="eventDate__startdate"
        dateTime={`${startDate.Y ? `${startDate.Y}-` : ''}${startDate.m}-${startDate.d}`}
      >
        <div className="eventDate__shape-wrapper">
          <div className="eventDate__shape" />
        </div>
        {showWeekday && <span className="eventDate__year">{startDate.w}</span>}
        <span className="eventDate__day">
          {startDate.d}
          {locale !== 'en' && '.'}
        </span>
        <span className="eventDate__month">{month[locale][startDate.m]}</span>
        <span className="eventDate__year">{startDate.Y}</span>
      </time>

      {/* When its a period event show endDate */}
      {period && (
        <time className="eventDate__enddate" dateTime={`${endDate.Y}-${endDate.m}-${endDate.d}`}>
          <div className="eventDate__shape-wrapper" aria-hidden="true">
            <div className="eventDate__shape" />
          </div>
          <span className="eventDate__day">
            {endDate.d}
            {locale !== 'en' && '.'}
          </span>
          <span className="eventDate__month">{month[locale][endDate.m]}</span>
          <span className="eventDate__year">{endDate.Y}</span>
        </time>
      )}
      {!showWeekday && hasTime && (
        <div className="eventDate__arrow-wrapper">
          <div className="eventDate__arrow">
            <LongArrowRight role="presentation" />
          </div>
        </div>
      )}
    </StyledEventDateA11y>
  );
};

EventDateA11y.propTypes = {
  isTeaser: PropTypes.bool,
  showWeekday: PropTypes.bool,
  isBig: PropTypes.bool,
  isSmall: PropTypes.bool,
  hasTime: PropTypes.bool,
  timeOnTop: PropTypes.bool,
  period: PropTypes.bool.isRequired,
  startDate: PropTypes.shape({
    w: PropTypes.string,
    d: PropTypes.string,
    m: PropTypes.string,
    Y: PropTypes.string
  }).isRequired,
  endDate: PropTypes.shape({
    d: PropTypes.string,
    m: PropTypes.string,
    Y: PropTypes.string
  }).isRequired
};

export default EventDateA11y;
